import JSONBig from 'json-bigint'
import { getStorage, STORAGE_KEYS } from './storage'

// 使用json-bigint处理BigInt序列化/反序列化
const JSONBigNative = JSONBig({ useNativeBigInt: true })

/**
 * 检查是否已登录
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn() {
  return !!getStorage(STORAGE_KEYS.TOKEN)
}

/**
 * 获取token
 * @returns {string|null} token字符串或null
 */
export function getToken() {
  return getStorage(STORAGE_KEYS.TOKEN)
}

/**
 * 获取用户信息
 * @returns {Object|null} 用户信息对象或null
 */
export function getUserInfo() {
  const userInfo = getStorage(STORAGE_KEYS.USER_INFO)
  if (userInfo) {
    // 如果已经是对象，直接返回
    if (typeof userInfo === 'object') {
      return userInfo
    }
    // 如果是字符串，尝试解析
    if (typeof userInfo === 'string') {
      try {
        // 先尝试使用json-bigint解析（处理BigInt）
        return JSONBigNative.parse(userInfo)
      } catch (e) {
        try {
          // 如果失败，尝试使用标准JSON解析
          return JSON.parse(userInfo)
        } catch (e2) {
          console.error('解析用户信息失败:', e2)
          return null
        }
      }
    }
  }
  return null
}

/**
 * 获取用户ID
 * @returns {string|null} 用户ID或null
 */
export function getUserId() {
  return getStorage(STORAGE_KEYS.USER_ID)
}

/**
 * 获取用户名
 * @returns {string|null} 用户名或null
 */
export function getUsername() {
  return getStorage(STORAGE_KEYS.USERNAME)
}

/**
 * 获取昵称
 * @returns {string|null} 昵称或null
 */
export function getNickName() {
  return getStorage(STORAGE_KEYS.NICK_NAME)
}

/**
 * 获取头像URL
 * @returns {string|null} 头像URL或null
 */
export function getAvatar() {
  return getStorage(STORAGE_KEYS.AVATAR)
}

/**
 * 获取角色类型
 * @returns {string|null} 角色类型或null
 */
export function getRoleType() {
  return getStorage(STORAGE_KEYS.ROLE_TYPE)
}

/**
 * 获取手机号
 * @returns {string|null} 手机号或null
 */
export function getPhone() {
  return getStorage(STORAGE_KEYS.PHONE)
}

/**
 * 获取邮箱
 * @returns {string|null} 邮箱或null
 */
export function getEmail() {
  return getStorage(STORAGE_KEYS.EMAIL)
}

/**
 * 获取账号状态
 * @returns {string|null} 账号状态或null
 */
export function getStatus() {
  return getStorage(STORAGE_KEYS.STATUS)
}

/**
 * 获取公司名称
 * @returns {string|null} 公司名称或null
 */
export function getEmpName() {
  return getStorage(STORAGE_KEYS.EMP_NAME)
}

/**
 * 退出登录
 * 清除本地存储的token和用户信息
 */
export function logout() {
  const { clearUserStorage } = require('./storage')
  clearUserStorage()
}

